<template>
  <Loading v-if="isLoading" />
  <div v-else>
    <zReportSidebar ref="zReportSidebar" />

    <div class="flex justify-between">
      <div class="flex justify-between">
        <p>Lorem ipsum dolor sit amet consectetur, adipisicing elit.</p>
      </div>
    </div>

    <!-- table -->
    <div class="data-list-list-view">
      <vs-table ref="table" class="mt-4" pagination search :max-items="10" :data="filteredZReports" @selected="onClicked">
        <template slot="thead">
          <vs-th>Type</vs-th>
          <vs-th sort-key="date">Date</vs-th>
          <vs-th>Terminal</vs-th>
          <vs-th>User</vs-th>
        </template>

        <template slot-scope="{ data }">
          <tbody>
            <vs-tr :data="tr" :key="tr.id" v-for="tr in data">
              <vs-td>
                <div class="product-name font-medium truncate flex flex-row items-center">
                  <div class="flex justify-start">
                    <img width="40" :src="OrderIcon" />
                    <div class="ml-4">
                      <div>Z report</div>
                      <small class="text-grey">{{ tr.endOfDayReportId.slice(0, 8) }}</small>
                    </div>
                  </div>
                </div>
              </vs-td>

              <vs-td>
                <div class="flex">
                  <feather-icon class="mr-1" icon="CalendarIcon" svgClasses="text-grey w-5 h-5" />
                  {{ tr.date | date }}
                </div>
              </vs-td>

              <vs-td>
                <div class="flex">
                  {{ tr.metadata.name }}
                </div>
              </vs-td>

              <vs-td>
                <div class="flex">
                  {{ tr.metadata.userName }}
                </div>
              </vs-td>
            </vs-tr>
          </tbody>
        </template>
      </vs-table>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import OrderIcon from "@/assets/images/order-icon.png";
import moment from "moment";
import zReportSidebar from "./zReportSidebar.vue";

export default {
  components: {
    zReportSidebar
  },
  props: {
    venueId: {
      type: String,
      default: undefined,
      required: false
    }
  },
  data() {
    return {
      OrderIcon,
      isLoading: true,

      //Create popup
      startWithSuggested: false,
      createPromptActive: false,

      activeVenueId: null
    };
  },
  watch: {
    venueId: {
      handler: async function () {
        this.isLoading = true;
        this.activeVenueId = this.venueId;
        // If no venue id specified, default to active venue
        if (typeof this.venueId == "undefined") {
          this.activeVenueId = this.$store.getters["venues/activeVenueId"];
        }

        await this.$store.dispatch("pos/zReports/getZReportsByVenue", { venueId: this.activeVenueId });

        this.isLoading = false;
      },
      immediate: true
    }
  },
  methods: {
    onClickCreateNew() {
      this.createPromptActive = true;
    },

    async createStockCount() {
      try {
        console.log("creating stock count");
        var response = await this.$store.dispatch("pos/stockCounts/createStockCount", {
          venueId: this.activeVenueId
        });

        this.$refs.zReportSidebar.show(response);

        await this.$store.dispatch("pos/stockCounts/getStockCountsByVenue", this.activeVenueId); // Refresh stock counts

        this.$vs.notify({
          title: "Stock count created",
          text: "A new draft stock count has been created."
        });
        this.startWithSuggested = false;
        this.createPromptActive = false;
      } catch (err) {
        this.$vs.notify({
          title: "Error",
          text: `Failed to create stock count: ${err}`,
          color: "danger"
        });
        console.error(err);
      }
    },
    onClicked(item) {
      this.$refs.zReportSidebar.show(item.endOfDayReportId);
    }
  },
  computed: {
    ...mapGetters({
      zReports: "pos/zReports/zReports"
    }),
    filteredZReports() {
      return this.zReports.slice().sort((a, b) => (a.createdAction.timestamp < b.createdAction.timestamp ? 1 : -1));
    }
  }
};
</script>